import { ProgramDto } from "@masterschool/course-builder-api"

export function isLegacyProgram(program: ProgramDto): boolean {
  return program.cohortType === "legacy"
}
